<template>
  <footer class="ma-footer">
    <div class="ma-footer__inner">
      <div class="ma-footer__top">
        <!-- Logo -->
        <div class="ma-footer__brand">
          <img src="../../../../../assets/logoblanco.png" alt="HIR Casa" class="ma-footer__logo" />
        </div>

        <!-- Nav columna 1 -->
        <nav class="ma-footer__nav">
          <router-link :to="{ name: 'cliente-cliente-home' }" class="ma-footer__link">Inicio</router-link>
          <router-link v-if="mostrarMenu" :to="{ name: 'cliente-cliente-perfil' }" class="ma-footer__link">Mi Perfil</router-link>
          <router-link v-if="mostrarMenu" :to="{ name: 'cliente-cliente-financiamiento' }" class="ma-footer__link">Financiamiento</router-link>
          <router-link v-if="mostrarMaterialApoyo" :to="{ name: 'cliente-cliente-materiales-apoyo' }" class="ma-footer__link">Material de Apoyo</router-link>
        </nav>

        <!-- Nav columna 2 -->
        <nav class="ma-footer__nav">
          <a class="ma-footer__link" href="https://hircasa.com.mx" target="_blank">Portal HIR Casa</a>
          <a class="ma-footer__link" href="https://hircasa.com.mx/aviso-privacidad/" target="_blank">Aviso de Privacidad</a>
          <a class="ma-footer__link" href="https://hircasa.com.mx/aviso-legal/" target="_blank">Términos y Condiciones</a>
        </nav>

        <!-- Redes sociales -->
        <div class="ma-footer__social">
          <a href="#" class="ma-footer__social-link" aria-label="Facebook"><i class="fab fa-facebook-f" /></a>
          <a href="#" class="ma-footer__social-link" aria-label="Twitter"><i class="fab fa-twitter" /></a>
          <a href="#" class="ma-footer__social-link" aria-label="Instagram"><i class="fab fa-instagram" /></a>
          <a href="#" class="ma-footer__social-link" aria-label="LinkedIn"><i class="fab fa-linkedin-in" /></a>
          <a href="#" class="ma-footer__social-link" aria-label="YouTube"><i class="fab fa-youtube" /></a>
          <a href="#" class="ma-footer__social-link" aria-label="WhatsApp"><i class="fab fa-whatsapp" /></a>
        </div>
      </div>

      <hr class="ma-footer__divider" />

      <div class="ma-footer__bottom">
        <!-- Dirección -->
        <div class="ma-footer__contact">
          <p>Av. Desierto de los Leones No. 46, Nivel 1, Col. San Ángel, Álvaro Obregón, C.P. 01000, Ciudad de México.</p>
          <a class="ma-footer__maps-btn" href="https://goo.gl/maps/EDePb6fTgEWJZgsJ8" target="_blank">
            <i class="fas fa-map-marker-alt" /> Abrir en Google Maps
          </a>
        </div>

        <!-- Horario y contacto -->
        <div class="ma-footer__contact">
          <p>Horario de Atención:</p>
          <p><i class="fas fa-clock" /> Lun - Vie: 09:00 - 18:00</p>
          <p><a class="ma-footer__contact-link" href="tel:+525555119910"><i class="fas fa-phone-alt" /> 55 5511 9910</a></p>
          <p><a class="ma-footer__contact-link" href="tel:+528004472272"><i class="fas fa-phone-alt" /> 800 hircasa (447 2272)</a></p>
          <p><a class="ma-footer__contact-link" href="mailto:atencionaclientes@hircasa.com.mx"><i class="fas fa-envelope" /> atencionaclientes@hircasa.com.mx</a></p>
        </div>

        <!-- Certificaciones -->
        <div class="ma-footer__certs">
          <p>Certificaciones</p>
          <img src="../../../../../assets/certificaciones.png" alt="Certificaciones" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { useStore } from '../../../store'

const props = withDefaults(defineProps<{
  mostrarMenu?: boolean
}>(), { mostrarMenu: false })

const store = useStore()
const mostrarMaterialApoyo = import.meta.env.VITE_CLIENTE_CLIENTE_MOSTRAR_MATERIAL_DE_APOYO === '1'
</script>

<style scoped>
.ma-footer {
  background-color: var(--ds-secondary-main);
  padding: 40px 0 16px;
  font-family: var(--ds-font-family-base);
  font-size: var(--ds-subtitle14-size);
  color: #ffffff;
}

.ma-footer__inner {
  max-width: 1208px;
  margin: 0 auto;
  padding: 0 24px;
}

.ma-footer__top {
  display: flex;
  gap: 48px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.ma-footer__logo { width: 190px; }

.ma-footer__nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ma-footer__link {
  color: #ffffff;
  text-decoration: none;
  font-weight: var(--ds-subtitle8-weight);
  transition: opacity 0.2s;
}
.ma-footer__link:hover { opacity: 0.75; }

.ma-footer__social {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.ma-footer__social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #ffffff;
  color: var(--ds-secondary-main);
  font-size: 16px;
  text-decoration: none;
  transition: opacity 0.2s;
}
.ma-footer__social-link:hover { opacity: 0.85; }

.ma-footer__divider {
  border: none;
  border-top: 1px solid rgba(161, 181, 216, 0.5);
  margin: 24px 0;
}

.ma-footer__bottom {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.ma-footer__contact {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 260px;
}

.ma-footer__contact-link {
  color: #ffffff;
  text-decoration: none;
}
.ma-footer__contact-link:hover { text-decoration: underline; }

.ma-footer__maps-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #ffffff;
  border-radius: var(--ds-radius-button);
  color: #ffffff;
  padding: 6px 16px;
  text-decoration: none;
  font-weight: var(--ds-subtitle8-weight);
  width: fit-content;
  margin-top: 8px;
}
.ma-footer__maps-btn:hover { background-color: rgba(255,255,255,0.1); }

.ma-footer__certs {
  margin-left: auto;
}
.ma-footer__certs img { width: 100%; max-width: 280px; }
</style>
